import { UploadOrdersResponse } from '../../../../../setup/apiTypes/orders';
import apiRoutes from '../../../../../setup/consts/apiRoutes';
import { makeMutationFn } from '../../../../../utils/reactQuery';

export const UPLOAD_ORDERS_MUTATION_FN = makeMutationFn<
  FormData,
  UploadOrdersResponse
>(apiRoutes.ORDERS_UPLOAD);
